import Http from "./base-http";

class Store extends Http {
  deleteStore(id) {
    return this.destroy(id);
  }
  updateStore(id, data){
    return this.client.put(`/${id}`, data)
  }
}

const StoreObj = new Store({
  modelUrlPrefix : "store"
});

export default StoreObj;